/** @jsx jsx */
import { jsx } from 'theme-ui';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getGatsbyImageData } from 'gatsby-source-sanity';
import { useSanityConfig } from '../../utils/useSanityConfig';
import React from 'react';
import {
	useImage,
	GalleryContextProvider,
	useOpenIndex,
	useClose,
	useNext,
	usePrev,
	useHasNext,
	useHasPrev
} from './GalleryContext';
import { Modal } from '../Modal';

const style = {
	variant: 'text.header',
	height: ['100px',null,'100%'],
	position: 'relative',
	gridRow: [ 2, null, 1 ],
	alignSelf: 'center',
	fontSize: 8,
	textAlign: 'center'
};

const NextButton = () => {
	const hasNext = useHasNext();
	const next = useNext();
	return (
		<div
			onClick={(e) => {
				next();
			}}
			sx={{ ...style, gridColumn: [2,null,'3'] }}
		>
			{hasNext ? (
				<div
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)'
					}}
				>
					{'>'}
				</div>
			) : (
				''
			)}
		</div>
	);
};

const PrevButton = () => {
	const hasPrev = useHasPrev();
	const prev = usePrev();
	return (
		<div
			onClick={(e) => {
				prev();
			}}
			sx={{ ...style, gridColumn: '1' }}
		>
			{hasPrev ? (
				<div
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)'
					}}
				>
					{'<'}
				</div>
			) : (
				''
			)}
		</div>
	);
};

const GalleryModal = () => {
	const image = useImage();
	const close = useClose();
	const next = useNext();
	return image ? (
		<Modal onClose={close}>
			<div
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
				}}
				sx={{ display: 'grid', }}
			>
				<PrevButton />
				<GatsbyImage
					onClick={next}
					image={image}
					sx={{
						cursor: 'pointer',
						variant: 'variants.containerBoxShadow',
						maxWidth: '1200px',
						maxHeight: '80vh',
						width: [ '80vw', null, '80vw' ],
						mx: 'auto',
						//	variant: 'variants.sanityFigure',
						gridColumn: ['1 / span 2',null,'2'],
						gridRow: 1
					}}
					alt={image.alt}
				/>
				<NextButton />
			</div>
		</Modal>
	) : (
		<React.Fragment />
	);
};

const Image = ({ image, onClick }) => {
	return (
		<React.Fragment>
			<GatsbyImage
				onClick={onClick}
				image={image}
				sx={{
					cursor: 'pointer',
					minHeight: [ '200px', 'auto', null, null, null ],
					m: 1,
					variant: 'variants.sanityFigure'
				}}
				alt={image.alt}
			/>
			{/* {image.caption && (
				<figcaption
					sx={{
						color: 'grey',
						fontSize: 'small',
						textAlign: 'center',
						mt: 1
					}}
				>
					{image.caption}
				</figcaption>
			)} */}
		</React.Fragment>
	);
};

const Gallery = ({ images }) => {
	const openIndex = useOpenIndex();
	return (
		<React.Fragment>
			{images.map((i, index) => <Image image={i} onClick={() => openIndex(index)} />)}
		</React.Fragment>
	);
};

export default ({ node }) => {
	const { images } = node;

	if (!images) {
		return null;
	}
	const { sanityProjectId, sanityDataset } = useSanityConfig();
	const sanityConfig = { projectId: sanityProjectId, dataset: sanityDataset };
	const gatsbyImagesSmall = images.map((i) =>
		getGatsbyImageData(i, { fit: 'crop', width: 200, height: 200 }, sanityConfig)
	);

	const gatsbyImagesBig = images.map((i) => getGatsbyImageData(i, { fit: 'scale', width: 1200 }, sanityConfig));

	return (
		<GalleryContextProvider images={gatsbyImagesBig}>
			<GalleryModal />
			<Gallery images={gatsbyImagesSmall} />
		</GalleryContextProvider>
	);
};
